/// <reference path="../../auth_form_default/js/gmr.d.ts" />
/// <reference path="../../auth_form_default/js/IFormState.d.ts" />
export default class DefaultForm {
    protected state : IFormState;
    protected $form : JQuery;

    public init (options : any) {
        throw new Error('Not implemented');
    }

    public showForm () {
        if (!this.state.rendered) {
            throw new Error('You need render form before show');
        }
        if (!this.state.visible) {
            this.$form.show();
            this.state.visible = true;
        }
    }

    public hideForm () {
        this.$form.hide();
        this.state.visible = false;
    }
    loadCss = function (file) {
        var link = document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", file);
        document.getElementsByTagName("head")[0].appendChild(link);
    }
}